import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {Constants} from '../../../shared/config/constants.config';
import * as moment from 'moment';
import {WalletTransactionViewModel} from '../../../shared/viewModels/walletTransaction.viewModel';
import {WalletService} from '../../services/wallet.service';
import {CountriesService} from '../../../shared/services/countries.service';
import {Country} from '../../../shared/models/country.model';
import {forkJoin, Observable} from 'rxjs';
import {LocalisationService} from '../../../shared/services/localisation.service';

@Component({
    selector: 'app-wallet-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class SettingsComponent implements OnInit {

    paypal_email: string;
    selected_country: string;
    transactions: WalletTransactionViewModel[] = [];
    countries: Country[];

    constructor(
        private readonly countriesService: CountriesService,
        private readonly walletService: WalletService,
        private readonly localisationService: LocalisationService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly constants: Constants,
    ) {
        this.selected_country = 'BG';
    }

    ngOnInit() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);


        forkJoin([
            this.countriesService.getCountries(),
            this.walletService.getTransactions(0),
            this.walletService.getPayoutSetting()
        ]).subscribe(([countries, transactions, payoutSetting]) => {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);

            this.countries = countries;
            this.transactions = transactions;
            this.paypal_email = payoutSetting.paypal_email;

            if (payoutSetting.transfer_method_country.length > 0) {
                this.selected_country = payoutSetting.transfer_method_country;
            }
        });
    }

    formatDate(created_at: string) {
        return moment(created_at).format('DD.MM.YYYY / HH:mm');
    }

    onCountryChange($event) {
        // @ts-ignore
        this.selected_country = event.target.value;
    }

    update() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.walletService.updatePayoutSettings({paypal_email: this.paypal_email, country: this.selected_country}).subscribe(response => {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
        }, () => {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            alert(this.localisationService.localise('fill_all_fields'));
        });
    }

}
